import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';
import userService from '../services/userService';

// layouts
const Layout = lazy(() => import('../components/layout/Layout'));
const LayoutBackend = lazy(() => import('../components/layout/LayoutBackend'));

export const PrivateRoute = ({ check, component: Component, userLogined, theme, admin, ...rest }) => {
  //console.log('🚀 ~ PrivateRoute ~ admin', admin);
  // console.log('pr: 1');
  if (userLogined) {
    // console.log('pr: 2');
    // checks
    if (!admin && check) {
      // console.log('pr: 3');
      // console.log('🚀 ~ PrivateRoute ~ admin && check:', admin, check);
      if (!userService.isPageActive(check)) {
        // console.log('pr: 4');
        const to = userService.getDefaultClientPath();
        return <Redirect to={to} />;
      }
    }

    // console.log('private component at ' + rest.path);
    if (theme) {
      // console.log('pr: 5');
      return (
        <Route
          {...rest}
          render={(props) => (
            <Layout theme={theme}>
              <Component {...props} admin={admin} />
            </Layout>
          )}
        />
      );
    }
    // console.log('pr: 6');

    return (
      <Route
        {...rest}
        render={(props) => (
          <LayoutBackend theme={theme}>
            <Component {...props} admin={admin} />
          </LayoutBackend>
        )}
      />
    );
  } else {
    // console.log('pr: 7');

    // console.log(' >> /login');
    if (!window.continueLinkAfterLogout) {
      window.continueLink = history.location;
    }
    window.continueLinkAfterLogout = false;
    const to = '/login';

    return <Redirect to={to} />;
  }
};

PrivateRoute.defaultProps = {
  admin: false,
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType,
  userLogined: PropTypes.bool.isRequired,
  admin: PropTypes.bool,
  theme: PropTypes.string,
  check: PropTypes.string,
};
